// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1155480985
// </auto-generated>
import {
  HttpClient,
  HttpParams,
  HttpHeaders,
  HttpEventType,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { Observable, Subject, Subscription } from 'rxjs';
import { SmartListResult, SmartListCriteria } from 'carehub-shared/smartlist';
import { Utils } from 'carehub-shared/utils';

import { Group } from './models/security/group';
import { UserSummary } from './models/security/usersummary';
import { TokenSummary } from './models/security/tokensummary';

export interface getUsersByGroupId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

export interface getPermissionsByGroupId_Filter {
  includeUnassigned: boolean;
  includeSpecifiedOnly: string[];
}

@Injectable({
  providedIn: 'root',
})
export class GroupsApiService {
  constructor(protected http: HttpClient) {}

  getAllGroups(
    criteria?: SmartListCriteria
  ): Observable<SmartListResult<Group>> {
    let url = environment.chiliSauceApiRoot + `/api/Groups`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    return this.http.get<SmartListResult<Group>>(url);
  }

  addGroup(newGroup: Group): Observable<Group> {
    const url = environment.chiliSauceApiRoot + `/api/Groups`;
    return this.http.post<Group>(url, newGroup);
  }

  getGroupById(groupGuid: string): Observable<Group> {
    const url = environment.chiliSauceApiRoot + `/api/Groups/${groupGuid}`;
    return this.http.get<Group>(url);
  }

  updateGroup(group: Group, groupGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Groups/${groupGuid}`;
    return this.http.put<any>(url, group);
  }

  deleteGroup(groupGuid: string): Observable<any> {
    const url = environment.chiliSauceApiRoot + `/api/Groups/${groupGuid}`;
    return this.http.delete(url);
  }

  getUsersByGroupId(
    groupGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getUsersByGroupId_Filter>
  ): Observable<SmartListResult<UserSummary>> {
    let url = environment.chiliSauceApiRoot + `/api/Groups/${groupGuid}/users`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<UserSummary>>(url, { params: params });
  }

  updateUsersForGroupId(groupGuid: string, ids: string[]): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Groups/${groupGuid}/users`;
    return this.http.put<any>(url, ids);
  }

  getPermissionsByGroupId(
    groupGuid: string,
    criteria?: SmartListCriteria,
    queryParams?: Partial<getPermissionsByGroupId_Filter>
  ): Observable<SmartListResult<TokenSummary>> {
    let url =
      environment.chiliSauceApiRoot + `/api/Groups/${groupGuid}/permissions`;
    if (criteria) {
      url += SmartListCriteria.toQueryParams(criteria);
    }
    const params = Utils.getHttpParams(queryParams);
    return this.http.get<SmartListResult<TokenSummary>>(url, {
      params: params,
    });
  }

  updatePermissionsForGroupId(
    groupGuid: string,
    tokens: TokenSummary[]
  ): Observable<any> {
    const url =
      environment.chiliSauceApiRoot + `/api/Groups/${groupGuid}/permissions`;
    return this.http.put<any>(url, tokens);
  }
}
